import { Helmet } from 'react-helmet-async';

import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import { buildDocumentTitle } from '../../utils/document-title.util';

export const HealthCheckPage = () => (
  <>
    <Helmet>
      <title>{buildDocumentTitle('Health Check')}</title>
    </Helmet>
    <Typography gutterBottom variant="h4">
      Health Check
    </Typography>
    <Typography gutterBottom variant="body1">
      Status: <strong>OK</strong>
    </Typography>
    <Alert severity="success">
      This page is used to check if the application is up and running. If you
      see this page, it means the application is up and running.
    </Alert>
  </>
);
